import { useQueryClient } from '@tanstack/react-query';
import { useAxiosMutation } from './use-axios.hook';
import { createArcgisSchema } from '../../api/arcgis-schemas.api';
import { CreateArcgisSchemaApiRequest } from '../../../../types/requests/arcgis-schemas/create-arcgis-schema.request';

const baseQueryKey = 'arcgis-schema';
const searchQueryKey = 'search';

export const useCreateArcgisSchema = () => {
  const queryClient = useQueryClient();
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: CreateArcgisSchemaApiRequest) => (await createArcgisSchema(params)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [baseQueryKey, searchQueryKey] }),
  });
  return [request, { ...result, arcgisSchema: data }] as const;
};
